export default __webpack_public_path__ + "static/media/diamond_tier.2f1e92dc.svg";